import { Component, EventEmitter, Input, Output } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { UtilityService } from 'src/app/_services/utility.service';

registerLocaleData(localeIt);

@Component({
  selector: 'app-card-membro-team',
  templateUrl: './card-membro-team.component.html',
  styleUrls: ['./card-membro-team.component.css']
})
export class CardMembroTeamComponent {
  @Input() data: any;
  user: any;
  fullName: any;
  @Output() getProfile: EventEmitter<any> = new EventEmitter<any>();

  constructor(public utilityService: UtilityService) {}

  ngOnInit() {
    this.user = this.data;
    this.fullName = 'profile.user.first_name + " " + profile.user.last_name';
  }
}
